(() => {
  const tagToken = (tag) => `tag:${tag.trim()}`;

  const stripShopTags = (value) => value.replace(/\s*tag:[^\s]+/g, '').trim();

  const prepareSearchForm = (form) => {
    const tag = form.dataset.pseudoShopSearchTag;
    if (!tag) return;

    const input = form.querySelector('input[name="q"]');
    if (!input) return;

    input.value = stripShopTags(input.value);

    form.addEventListener('submit', () => {
      const token = tagToken(tag);
      const cleanValue = stripShopTags(input.value);
      input.value = cleanValue ? `${cleanValue} ${token}` : token;
    });
  };

  document.querySelectorAll('form[data-pseudo-shop-search-tag]').forEach(prepareSearchForm);

  // 2026-05-23 Claude: PSYLOS1 風 fade-up アニメ（IntersectionObserver）
  const initPseudoShopAnim = () => {
    const targets = document.querySelectorAll('.pseudo-shop-anim');
    if (!targets.length) return;
    if (!('IntersectionObserver' in window)) {
      targets.forEach((el) => el.classList.add('is-visible'));
      return;
    }
    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      targets.forEach((el) => el.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      }
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    targets.forEach((el) => observer.observe(el));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPseudoShopAnim);
  } else {
    initPseudoShopAnim();
  }
})();
